import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import history from 'utils/history';

import userReducer from './userReducer';
import uiStateReducer from './uiStateReducer';
import foldersReducer from './foldersReducer';
import rolesReducer from './rolesReducer';
import teamReducer from './teamReducer';
import postsReducer from './postsReducer';
import countryReducer from './countryReducer';
import companyReducer from './companyReducer';
import categoryReducer from './categoryReducer';
import chatReducer from './chatReducer';
import readerReducer from './readerReducer';
import filesReducer from './filesReducer';
import competitionReducer from './competitionReducer';
import documentsReducer from './documentsReducer';
import contractReducer from './contractReducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    router: connectRouter(history),
    user: userReducer,
    folders: foldersReducer,
    roles: rolesReducer,
    uiState: uiStateReducer,
    team: teamReducer,
    posts: postsReducer,
    countries: countryReducer,
    company: companyReducer,
    chat: chatReducer,
    category: categoryReducer,
    reader: readerReducer,
    files: filesReducer,
    competition: competitionReducer,
    documents: documentsReducer,
    contract: contractReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
